import React from 'react'
import { Drawer } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import styles from './index.module.less'

export default ({ visible, title, width, children, onClose }) => {
  return <Drawer
    closable={false}
    width={width}
    placement="right"
    onClose={onClose}
    open={visible}
    className={styles['mn-drawer']}
  >
    <div className="mn-drawer-header">
      <div className="mn-drawer-header-title">{title}</div>
      <div className="close" onClick={onClose}>
        <Icon type="m-guanbi" className="mn-drawer-header-close" />
      </div>
    </div>
    {children}
  </Drawer>
}
